import { selectIsOfferRedesignExperimentActive } from 'shared/selectors/abExperiments';

import { IState } from '../store';

export const selectIsOfferPageRedesign = (state: IState) => {
  const isRedesignABActive = selectIsOfferRedesignExperimentActive(state);

  return isRedesignABActive;
};
